import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  products: (params) => axios.get(`${API}/catalog/products`, { params }).then((r) => r.data),
  product: (slugOrId) => axios.get(`${API}/catalog/products/${slugOrId}`).then((r) => r.data),
  categories: () => axios.get(`${API}/catalog/categories`).then((r) => r.data),
  home: () => axios.get(`${API}/catalog/home`).then((r) => r.data),
  newsletter: (email) => axios.post(`${API}/newsletter`, { email }).then((r) => r.data),
  contact: (payload) => axios.post(`${API}/contact`, payload).then((r) => r.data),
  deal: () => axios.get(`${API}/deal`).then((r) => r.data.deal),
  adminLogin: (password) => axios.post(`${API}/admin/login`, { password }).then((r) => r.data),
  saveDeal: (token, deal) =>
    axios.put(`${API}/deal`, deal, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data.deal),
  verify: (formData) => axios.post(`${API}/verify`, formData).then((r) => r.data),
  verificationStatus: (email) =>
    axios.get(`${API}/verification/status`, { params: { email } }).then((r) => r.data),
  announcements: () => axios.get(`${API}/announcements`).then((r) => r.data.items),
  flyerConfig: () => axios.get(`${API}/flyers/config`).then((r) => r.data.productIds),
  saveAnnouncements: (token, items) =>
    axios.put(`${API}/announcements`, { items }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data.items),
  saveFlyerConfig: (token, productIds) =>
    axios.put(`${API}/flyers/config`, { productIds }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data.productIds),
};

// Conversion analytics hooks — events are pushed to dataLayer so any tag
// manager can pick them up later. No third-party scripts are loaded.
export function track(event, payload = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...payload, ts: Date.now() });
  } catch (_) {
    /* analytics must never break UX */
  }
}

export const fmt = (n) =>
  typeof n === "number" ? `$${n.toFixed(2).replace(/\.00$/, "")}` : "";

// Products priced purely via option modifiers show "From $X" instead of $0.
export const priceLabel = (p) => {
  if (p.price > 0) return fmt(p.price);
  const mods = (p.options || [])
    .flatMap((o) => (o.choices || []).map((c) => c.priceModifier || 0))
    .filter((m) => m > 0);
  return mods.length ? `From ${fmt(Math.min(...mods))}` : "See options";
};
